import { ITEM_DEFINITION_STATES } from '../../apps/angularjs/constants/item-definitions';
import { STATES } from '../../apps/angularjs/constants/states';
import { BASE_PATH as MOVEIQ_BASE_PATH } from '../../apps/angularjs/components/steps/moveiq/constants';
import { BASE_PATH as HOMESERVICES_BASE_PATH } from '../../apps/angularjs/components/steps/home-services-app/constants';
import { BASE_PATH as PROMOTION_BASE_PATH } from '../../apps/angularjs/components/steps/promotions/app/constants';
import { BASE_PATH as INSURANCE_BASE_PATH } from '../../apps/angularjs/components/steps/insurance/constants';
// import { actions as moverAppActions } from '../../state';

const getQueryParams = queryParams => {
  const query = decodeURIComponent(queryParams.substr(1));
  if (!query) {
    return {};
  }
  const params = query.split('&').reduce((acc, keyValuePair) => {
    const split = keyValuePair.split('=');
    const [key, value] = split;
    return { ...acc, [key]: value };
  }, {});

  return params;
};

const moverAppActions = {
  router: {
    stateGo: (to, params, options) => ({
      type: '@@reduxUiRouter/stateGo',
      payload: {
        to,
        params,
        options,
      },
    }),
  },
};

export const daisyChainStepPaths = {
  HOME_SERVICE_APP: `^${HOMESERVICES_BASE_PATH}`,
  PROMOTION: `^${PROMOTION_BASE_PATH}`,
  MOVEIQ: `^${MOVEIQ_BASE_PATH}`,
  INSURANCE: `^${INSURANCE_BASE_PATH}`,
  UTILITY: /^\/utilities(\/.*)?$/,
  FORWARD_MAIL: /^\/forward-mail(\/.*)?$/,
  UPDATE_ACCOUNT: /^\/update-accounts(\/.*)?$/,
};

export const moverAppPaths = {
  DASHBOARD: /^\/dashboard(\/?.*)?$/,
  PROFILE: /^\/account\/profile/,
  MOVES_SUMMARY: /^\/account\/moves\/(\d*)\/summary$/,
  MOVES_NEW: /^\/account\/moves\/new/,
};

const pathsToCheck = {
  ...daisyChainStepPaths,
  ...moverAppPaths,
};

export const isAMoverAppRoute = path =>
  Object.keys(pathsToCheck).some(key => path.match(pathsToCheck[key]));

export const directChangeToMoverApp = path => {
  const updStore = angular
    .element(document.querySelector('upd-mover-app'))
    .injector()
    .get('updStore');
  if (path.match(daisyChainStepPaths.HOME_SERVICE_APP)) {
    return updStore.dispatch(
      moverAppActions.router.stateGo(ITEM_DEFINITION_STATES.HOME_SERVICE_APP)
    );
  } else if (path.match(daisyChainStepPaths.PROMOTION)) {
    return updStore.dispatch(
      moverAppActions.router.stateGo(ITEM_DEFINITION_STATES.PROMOTION)
    );
  } else if (path.match(daisyChainStepPaths.MOVEIQ)) {
    return updStore.dispatch(
      moverAppActions.router.stateGo(ITEM_DEFINITION_STATES.MOVEIQ)
    );
  } else if (path.match(daisyChainStepPaths.INSURANCE)) {
    return updStore.dispatch(
      moverAppActions.router.stateGo(ITEM_DEFINITION_STATES.INSURANCE)
    );
  } else if (path.match(daisyChainStepPaths.UTILITY)) {
    return updStore.dispatch(
      moverAppActions.router.stateGo(ITEM_DEFINITION_STATES.UTILITY)
    );
  } else if (path.match(daisyChainStepPaths.FORWARD_MAIL)) {
    return updStore.dispatch(
      moverAppActions.router.stateGo(ITEM_DEFINITION_STATES.FORWARD_MAIL)
    );
  } else if (path.match(daisyChainStepPaths.UPDATE_ACCOUNT)) {
    return updStore.dispatch(
      moverAppActions.router.stateGo(ITEM_DEFINITION_STATES.UPDATE_ACCOUNT)
    );
  } else if (path.match(moverAppPaths.DASHBOARD)) {
    const match = path.match(moverAppPaths.DASHBOARD)[1] || '';
    const { moveId } = getQueryParams(match);
    return updStore.dispatch(
      moverAppActions.router.stateGo(STATES.DASHBOARD, { moveId })
    );
  } else if (path.match(moverAppPaths.PROFILE)) {
    return updStore.dispatch(moverAppActions.router.stateGo(STATES.PROFILE));
  } else if (path.match(moverAppPaths.MOVES_SUMMARY)) {
    const moveId = path.match(moverAppPaths.MOVES_SUMMARY)[1];
    return updStore.dispatch(
      moverAppActions.router.stateGo(STATES.MOVES_SUMMARY, { moveId })
    );
  } else if (path.match(moverAppPaths.MOVES_NEW)) {
    return updStore.dispatch(moverAppActions.router.stateGo(STATES.MOVES_NEW));
  }
  return Promise.resolve();
};
